import { ProjectDrawingStateTypes, ProjectDrawingActionTypes } from "./ProjectDrawing.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ProjectDrawingStateTypes = {
  fetchAll: resetApiCallState([]),
};

const ProjectDrawingReducer = (
  state: ProjectDrawingStateTypes = INITIAL_STATE,
  action: any
): ProjectDrawingStateTypes => {
  switch (action.type) {
    case ProjectDrawingActionTypes.FETCH_ALL_PROJECT_DRAWING:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProjectDrawingActionTypes.FETCH_ALL_PROJECT_DRAWING_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProjectDrawingActionTypes.FETCH_ALL_PROJECT_DRAWING_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProjectDrawingActionTypes.FETCH_ALL_PROJECT_DRAWING_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ProjectDrawingReducer;
